import { z } from "zod";
import { validateDateRange } from "./custom-validations";

export const dateRangeSchema = z.union([
    z.date(),
    z.string().regex(/^\d{2}\/\d{2}\/\d{4}$/, "Data inválida").transform((str) => {
        const [day, month, year] = str.split("/");
        return new Date(Number(year), Number(month) - 1, Number(day));
    })
]).refine(
    (date) => validateDateRange(date),
    {
        message: "Use uma data válida.",
    }
);

// Helper for string dates that need coercion
export const stringDateRangeSchema = z.string().transform((str) => new Date(str)).pipe(dateRangeSchema);

// Helper for string dates that should remain strings (e.g. for existing string-typed interfaces)
export const dateRangeStringSchema = z.string().refine((str) => validateDateRange(str), {
    message: "Use uma data válida.",
});
